import { COLORS } from "../../../constants";
import { HALO } from "../../../constants/colors";
export var tabStylesFn = function (size) { return ({
    color: COLORS.P_HIGH_EMPHASIS,
    px: size === "medium" ? 6 : 4,
    py: size === "medium" ? 3 : 2,
    fontWeight: 400,
    fontSize: "14px",
    opacity: "1 !important",
    lineHeight: "24px",
    minHeight: "0",
    minWidth: "0",
    borderRadius: "100px",
    "&:focus-visible": {
        boxShadow: HALO,
    },
    "&:hover:not(.Mui-selected) .MuiTypography-root": {
        color: COLORS.P_MED_EMPHASIS,
    },
    "&:active:not(.Mui-selected) .MuiTypography-root": {
        color: COLORS.P_MED_LOW_EMPHASIS,
    },
    "&.Mui-disabled .MuiTypography-root": {
        color: COLORS.P_DISABLED,
    },
    "&.Mui-selected": {
        bgcolor: COLORS.WHITE,
        border: "1px solid ".concat(COLORS.P_OUTLINE),
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.05), 0px 3px 18px rgba(0, 0, 0, 0.1)",
        "&:focus-visible": {
            boxShadow: "none",
        },
        // svg active
        ".MuiSvgIcon-root": {
            color: COLORS.SAY_COBALT,
        },
    },
    // svg
    ".MuiSvgIcon-root": {
        color: COLORS.BLACK,
    },
    ".MuiTab-iconWrapper": {
        marginRight: "12px",
    },
}); };
